import {configureStore} from '@reduxjs/toolkit'
import {reducer} from "./slices/rootSlice";
import logger from 'redux-logger'

export const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
})
